export const NOT_VERIFIED_MESSAGE = 'Please verify';
